import React from "react";
import { BannerContextInterface, BannerDetails } from "@pepdirect/v3/ui/Banner";

export const BannerContext = React.createContext<BannerContextInterface>({
  setBannerDetails: (_details: BannerDetails | null) => {},
  bannerDetails: null,
  setBannerAutoDismiss: (_dismissBanner: boolean) => {},
  bannerAutoDismiss: false,
});
